export const PATH_WEATHERS = `/weathers`;

export function fetchWeathersInfo(args) {
  return this.http.get(`${PATH_WEATHERS}/${args.tmFc}`);
}
